import { motion } from "framer-motion";
import { Quote } from "lucide-react";

// Real client testimonials.
const ITEMS = [
  {
    quote:
      "Mayur is a true expert in his field. I’ve personally worked with him on multiple hiring mandates, and he consistently connects the right people with the right opportunities. Professional, reliable, and highly effective throughout the process. Highly recommended.",
    author: "CEO",
    company: "Liquidity Provider · London",
    img: null,
  },
  {
    quote:
      "Mayur is an exceptionally professional recruiter. His screening process is sharp and efficient — he connects high‑caliber talent with high‑performance businesses. Always responsive, insightful, and available throughout the hiring process. Highly recommended for both companies hiring elite talent and professionals exploring new opportunities.",
    author: "COO",
    company: "Prop Trading Firm · Hong Kong",
    img: null,
  },
  {
    quote:
      "I highly recommend Mayur for his exceptional recruitment expertise within the forex and trading industry. His professionalism, market knowledge, and dedication helped me secure multiple strong opportunities. If you’re looking for a recruiter who genuinely delivers results, Mayur is someone you can trust.",
    author: "Regional Commercial Director",
    company: "FX/CFD Brokerage · Dubai",
    img: null,
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-20 sm:py-24 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-6">
          <div>
            <div className="text-[11px] font-mono uppercase tracking-[0.22em] text-[#D9F99D]/90">
              Client Voices
            </div>
            <h2
              data-testid="testimonials-heading"
              className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-white"
            >
              Trusted by operators who
              <br />
              <span className="zx-hi">don&apos;t miss.</span>
            </h2>
          </div>
          <p className="max-w-md text-neutral-200">
            Real client voices on what working with us looks like —
            from CEOs, COOs, and commercial leaders across global trading firms.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
          {ITEMS.map((t, i) => {
            const accents = [
              { accent: "green",  color: "#D9F99D" },
              { accent: "purple", color: "#A78BFA" },
              { accent: "blue",   color: "#60A5FA" },
            ];
            const a = accents[i % accents.length];
            return (
              <motion.figure
                key={i}
                initial={{ opacity: 0, y: 22 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.6, delay: i * 0.1 }}
                data-testid={`testimonial-card-${i}`}
                data-accent={a.accent}
                className="zx-card group p-8"
              >
                <div
                  aria-hidden
                  className="absolute -top-14 -right-10 w-48 h-48 rounded-full opacity-55"
                  style={{ background: `radial-gradient(circle, ${a.color}22, transparent 70%)`, filter: "blur(26px)" }}
                />
                <Quote size={26} style={{ color: a.color }} />
                <blockquote className="mt-5 text-base sm:text-lg text-neutral-200 leading-relaxed relative">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-4 pt-6 border-t border-white/5 relative">
                  <div
                    className="h-11 w-11 rounded-full overflow-hidden border flex items-center justify-center text-xs font-mono"
                    style={{ borderColor: `${a.color}35`, background: "#0a1424", color: a.color }}
                  >
                    {t.img ? (
                      <img src={t.img} alt="" loading="lazy" decoding="async" className="h-full w-full object-cover" />
                    ) : (
                      t.author[0]
                    )}
                  </div>
                  <div>
                    <div className="text-sm font-medium text-white">{t.author}</div>
                    <div className="text-xs text-neutral-500">{t.company}</div>
                  </div>
                </figcaption>
              </motion.figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
